// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {358: "be3e55305ab79a38",498: "a6dad66423bf3fd7",807: "f6b32fdde63060e9",896: "c4dc96f919db1c12",}[chunkId] + ".css"
}